import React, { Component } from "react";
import "../../../styles/components/legal/Legal.scss";
import HYUNDAI_ICON from "../../../styles/images/brands/hyundai.svg";

class TC extends Component {
  render() {
    return (
      <div className="hyundai-section">
        <div>
          <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
          <title />
          <meta name="generator" content="LibreOffice 6.4.7.2 (Linux)" />
          <meta name="author" content="support@go-evio.com" />
          <meta name="created" content="2023-06-20T11:29:00" />
          <meta name="changed" content="2023-06-26T10:45:16.470066592" />
          <meta name="AppVersion" content={16.0} />
          <meta
            name="ContentTypeId"
            content="0x0101000BB2643375481343AFB5489E80F1ADEF"
          />
          <meta name="Creator" content="Acrobat PDFMaker 11 for Word" />
          <meta name="DocSecurity" content={0} />
          <meta name="HyperlinksChanged" content="false" />
          <meta name="LinksUpToDate" content="false" />
          <meta name="MediaServiceImageTags" content />
          <meta name="ScaleCrop" content="false" />
          <meta name="ShareDoc" content="false" />
          <style
            type="text/css"
            dangerouslySetInnerHTML={{
              __html:
                '\n\t\t@page { size: 21cm 29.72cm; margin-left: 2.82cm; margin-right: 2.79cm; margin-top: 1.94cm; margin-bottom: 1.71cm }\n\t\tp { margin-left: 0.93cm; text-indent: -0.75cm; margin-top: 0.21cm; margin-bottom: 0cm; direction: ltr; text-align: justify; orphans: 0; widows: 0; background: transparent }\n\t\tp.western { font-family: "Carlito", serif; font-size: 12pt; so-language: pt-PT }\n\t\tp.cjk { font-family: "Carlito"; font-size: 12pt }\n\t\tp.ctl { font-family: "Carlito"; font-size: 12pt }\n\t\th1 { margin-left: 0.18cm; margin-top: 0.21cm; margin-bottom: 0cm; direction: ltr; text-align: justify; orphans: 0; widows: 0; background: transparent }\n\t\th1.western { font-family: "Carlito", serif; font-size: 12pt; so-language: pt-PT; font-weight: bold }\n\t\th1.cjk { font-family: "Carlito"; font-size: 12pt; font-weight: bold }\n\t\th1.ctl { font-family: "Carlito"; font-size: 12pt; font-weight: bold }\n\t\ta:link { color: #0000ff; text-decoration: underline }\n\t\ta:visited { color: #800080; text-decoration: underline }\n\t',
            }}
          />
          <div title="header">
            <p
              lang="pt-PT"
              className="western"
              align="center"
              style={{
                marginLeft: "0cm",
                textIndent: "0cm",
                marginTop: "0cm",
                marginBottom: "1.48cm",
                lineHeight: "5%",
              }}
            >
              <br />
            </p>
            <p
              align="center"
              style={{
                marginTop: "0.21cm",
                marginBottom: "0cm",
                lineHeight: "0.6cm",
              }}
            >
              <img
                className="brand-img"
                src={HYUNDAI_ICON}
                name="Picture 1"
                align="bottom"
                height={200}
                border={0}
                alt="Acp"
              />
            </p>
          </div>
          <p
            lang="pt-PT"
            className="western"
            align="left"
            style={{ marginLeft: "0cm", textIndent: "0cm", marginTop: "0cm" }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            className="western"
            align="left"
            style={{
              marginLeft: "0cm",
              textIndent: "0cm",
              marginTop: "0.02cm",
            }}
          >
            <br />
          </p>
          <h1
            lang="pt-PT"
            className="western"
            align="center"
            style={{
              marginTop: "0.09cm",
            }}
          >
            Termos e Condições de utilização da plataforma Hyundai Blue
          </h1>
          <p
            lang="pt-PT"
            className="western"
            align="left"
            style={{ marginLeft: "0cm", textIndent: "0cm", marginTop: "0cm" }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            className="western"
            align="left"
            style={{
              marginLeft: "0cm",
              textIndent: "0cm",
              marginTop: "0.01cm",
            }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            className="western"
            style={{
              marginLeft: "0.18cm",
              marginRight: "0.2cm",
              textIndent: "0cm",
              marginTop: "0cm",
              lineHeight: "115%",
            }}
          >
            Os termos e condições seguintes (doravante referidos como “Termos e
            Condições”) regulam o acesso e a utilização da plataforma eletrónica
            de serviços de mobilidade elétrica Hyundai Blue, disponível em{" "}
            <a href="https://webclient-hyundai.go-evio.com/">
              https://webclient-hyundai.go-evio.com
            </a>{" "}
            para os utilizadores empresariais e/ou na Play Store e na App Store
            (doravante, “plataforma Hyundai Blue”) para os utilizadores
            individuais, empresariais ou outras entidades que se registem nesta
            plataforma (doravante, o “Utilizador” ou os “Utilizadores”)
            <font color="#676767">.</font>
          </p>
          <ol>
            <li>
              <p
                lang="pt-PT"
                align="left"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma Hyundai Blue destina-se a utilizadores de
                    veículos elétricos, bem como a agentes económicos e
                    entidades do setor público ou social que pretendam usufruir
                    e/ou promover os benefícios associados à mobilidade
                    elétrica.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Ao aceder, instalar ou usar a plataforma Hyundai Blue, o
                    Utilizador manifesta concordância, sem reservas, com os
                    presentes Termos e Condições, pelo que deve proceder à
                    leitura dos mesmos previamente a utilizar a plataforma
                    Hyundai Blue.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Se não concordar com os presentes Termos e Condições, o
                    Utilizador não deve usar a plataforma Hyundai Blue nem
                    descarregar ou subscrever qualquer material ou serviço que
                    esta disponibilize.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os serviços são disponibilizados ao Utilizador pela
                    sociedade HYUNDAI PORTUGAL, S.A., com sede na Rua Daciano
                    Baptista Marques 245, Edifício D, 5ºC – Lake Towers,
                    4400-617 Vila Nova de Gaia, pessoa coletiva número
                    500&nbsp;820 384 (doravante, “HYUNDAI”), na qualidade de
                    agente comercial, sendo que:
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            lang="pt-PT"
            style={{
              marginRight: "0.2cm",
              textIndent: "0cm",
              marginTop: "0.21cm",
              lineHeight: "115%",
            }}
          >
            –{" "}
            <font size={2} style={{ fontSize: "11pt" }}>
              <font size={3} style={{ fontSize: "12pt" }}>
                no caso dos carregamentos ad hoc nas redes MOBI.E, EVIO e redes
                de operadores noutros países através de contratos instantâneos
                entre o Utilizador e a EVIO (EVIO – Electrical Mobility, S.A.,
                com sede na Av. D. Afonso Henriques, 1825, 4450-017 Matosinhos),
                na qualidade de comercializador de eletricidade para a
                mobilidade elétrica, titular do registo n.º 20, de 10 de julho
                de 2020, os serviços são disponibilizados pela EVIO;
              </font>
            </font>
          </p>
          <p
            lang="pt-PT"
            style={{
              marginRight: "0.2cm",
              textIndent: "0cm",
              marginTop: "0.21cm",
              lineHeight: "115%",
            }}
          >
            <font size={2} style={{ fontSize: "11pt" }}>
              <font size={3} style={{ fontSize: "12pt" }}>
                - no caso de celebração de contratos de prestação de serviço
                para a mobilidade elétrica entre o Utilizador e a GOCHARGE
                (GOCHARGE, S.A., com sede na Avenida Vasco da Gama, 1410,
                4430-247 Vila Nova de Gaia), os serviços são disponibilizados
                pela GOCHARGE.
              </font>
            </font>
          </p>
          <ol start={5}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador reconhece que os serviços prestados através da
                    plataforma Hyundai Blue se dirigem a pessoas singulares
                    maiores de 18 anos e/ou a pessoas coletivas. No caso de
                    pessoa singular, ao aceder à plataforma Hyundai Blue, o
                    Utilizador declara ser maior de 18 anos. O Utilizador
                    reconhece e aceita que o acesso e utilização da plataforma
                    Hyundai Blue são da sua exclusiva responsabilidade,
                    comprometendo-se a utilizar a plataforma Hyundai Blue e os
                    respetivos serviços em conformidade com a Lei vigente e de
                    acordo com os presentes Termos e Condições.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.22cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A HYUNDAI reserva-se o direito de modificar e/ou atualizar
                    os presentes Termos e Condições sempre que o considere
                    pertinente, mediante o respetivo alerta prévio com quinze
                    dias de antecedência na plataforma Hyundai Blue e envio de
                    e-mail aos Utilizadores registados, a fim de as alterações
                    poderem ser conhecidas de modo informado pelos Utilizadores
                    no momento em que acedam à plataforma Hyundai Blue e
                    previamente a uma nova utilização desta, em conformidade com
                    o quadro legal aplicável aos contratos de adesão. Após uma
                    alteração dos Termos e Condições e respetiva comunicação ao
                    Utilizador, a utilização subsequente da plataforma Hyundai
                    Blue significa a aceitação por parte do Utilizador dos
                    Termos e Condições modificados.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <a name="_Hlk121366070" />
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    As diferentes componentes do tarifário e/ou a fórmula de
                    cálculo do valor em cada momento devido pelo Utilizador como
                    contrapartida pelos serviços da plataforma Hyundai Blue de
                    utilização de postos de carregamento são disponibilizadas ao
                    Utilizador imediatamente antes da realização da respetiva
                    operação utilizando, para o efeito, quer informação da
                    própria HYUNDAI, quer também informação prestada por
                    entidades terceiras, nomeadamente, entidades gestoras de
                    redes, operadores de postos de carregamento, plataformas de
                    roaming, reguladores e autoridades tributárias.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os Termos e Condições estão disponíveis nas aplicações de
                    utilização da plataforma Hyundai Blue para consulta pelo
                    Utilizador, salvo situações de indisponibilidade de sistemas
                    ou outro erro alheio à HYUNDAI que impeça a disponibilização
                    da informação.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador deve manter uma cópia dos Termos e Condições
                    num ficheiro autónomo, no seu dispositivo ou em formato de
                    papel, para referência futura, sem prejuízo de os registos
                    digitais da plataforma Hyundai Blue associados à prestação
                    de cada serviço serem considerados suficientes para efeitos
                    de prova contratual.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os Termos e Condições regem-se e são interpretados de acordo
                    com a Lei portuguesa, aceitando o Utilizador submeter-se à
                    jurisdição exclusiva dos tribunais portugueses para a
                    resolução de quaisquer litígios relacionados com os mesmos,
                    sem prejuízo do disposto em “Resolução de conflitos”.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Caso os postos de carregamento utilizados tenham termos e
                    condições localmente, afixados ou disponíveis em formato
                    digital, pertencentes às entidades terceiras operadoras do
                    posto de carregamento e responsáveis pela distribuição do
                    serviço, relativamente ao seu uso, deve o utilizador
                    proceder à leitura dos mesmos em completo dos presentes
                    Termos e Condições. Em tais casos, a HYUNDAI atuará como
                    prestador de serviços de mobilidade e a entidade
                    identificada como distribuidor, sendo da exclusiva
                    responsabilidade do Utilizador proceder à leitura e
                    respetiva aceitação dos Termos e Condições referidos.{" "}
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western" style={{ marginTop: "0.21cm" }}>
            Tratamento de dados pessoais
          </h1>
          <ol start={12}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador reconhece expressamente que, para que os
                    serviços descritos na plataforma Hyundai Blue possam ser
                    prestados, a HYUNDAI, a GOCHARGE e a EVIO necessitam de
                    recolher e tratar certas informações do Utilizador,
                    incluindo dados de natureza pessoal. Para esse efeito, ao
                    utilizar a plataforma Hyundai Blue, o Utilizador consente no
                    tratamento dos seus dados pessoais, por parte da Hyundai,
                    GOCHARGE e EVIO, bem como na partilha dos referidos dados
                    entre a Hyundai, GOCHARGE e a EVIO, no âmbito e para efeitos
                    dos serviços prestados.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Antes de utilizar e subscrever a plataforma Hyundai Blue, o
                    Utilizador deve consultar e aceitar a{" "}
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Política de Privacidade</b>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , onde encontrará detalhadas as condições de recolha e
                    tratamento dos seus dados pessoais, os direitos que lhe
                    assistem bem como outras informações relacionadas com o
                    tratamento de dados pessoais realizados pela HYUNDAI,
                    GOCHARGE e EVIO por subcontratantes e por entidades
                    terceiras.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <a href="https://ceme.go-evio.com/pt/site-ceme">Serviços</a>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma Hyundai Blue permite ao Utilizador beneficiar
                    dos seguintes serviços e funcionalidades:
                  </font>
                </font>
              </p>
              <ol type="a">
                <li>
                  <p lang="pt-PT">
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Serviços de mobilidade elétrica, que incluem a
                        utilização de postos de carregamento e o carregamento de
                        veículos elétricos em espaços onde existam postos de
                        carregamento conectados à rede Hyundai Blue;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT">
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Serviços de mobilidade elétrica, que incluem a
                        utilização de postos de carregamento e o carregamento de
                        veículos elétricos em postos de outras redes (MOBIE,
                        EVIO, GOCHARGE e roaming), a nível nacional e
                        internacional, que tenham acordo e integração com a
                        EVIO, sendo aplicável em Portugal o previsto no Anexo I
                        aos Termos e Condições;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT">
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Gestão de postos de carregamento e dos respetivos
                        utilizadores;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT" style={{ textIndent: "0cm" }}>
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Gestão de consumos de veículos elétricos e dos
                        utilizadores; respetivos
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT" style={{ textIndent: "0cm" }}>
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Acompanhamento do estado dos serviços;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT">
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Histórico de consumos e transações;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT">
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Estatísticas sobre os consumos;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT" style={{ textIndent: "0cm" }}>
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Comparação de custos entre postos de carregamento;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT" style={{ textIndent: "0cm" }}>
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Localização de postos de carregamento e consulta da sua
                        disponibilidade;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT" style={{ textIndent: "0cm" }}>
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Simulação de custo num posto de carregamento;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p lang="pt-PT" style={{ textIndent: "0cm" }}>
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Suporte ao Utilizador, através de FAQ e menu
                        “Contacte-nos”.
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western" style={{ marginTop: "0.3cm" }}>
            Acesso e condições de adesão
          </h1>
          <ol start={16}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.29cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma Hyundai Blue está disponível em{" "}
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <a href="https://webclient-hyundai.go-evio.com/">
                        https://webclient-hyundai.go-evio.com
                      </a>{" "}
                      , e/ou,
                    </font>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    enquanto App, na Play Store e na App Store, consoante o tipo
                    de adesão do Utilizador. O acesso através de smartphones
                    pressupõe a utilização do sistema operativo IOS (versão
                    mínima suportada IOS 13.0) ou Android (versão mínima
                    suportada 6.0)
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p lang="pt-PT">
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A utilização da plataforma Hyundai Blue e o acesso aos
                    respetivos serviços por pessoa singular implica a efetivação
                    de registo na App para telemóvel pelo Utilizador.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p lang="pt-PT">
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Ao registar-se na plataforma Hyundai Blue, o Utilizador irá,
                    para efeitos de autenticação, receber um SMS, serviço
                    fornecido pela Twilio, e/ou um email de confirmação de
                    registo.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Com a utilização da plataforma Hyundai Blue, o Utilizador
                    assegura que todos os dados pessoais introduzidos por si são
                    verdadeiros, atuais e completos. Qualquer ato do Utilizador
                    que seja considerado pela HYUNDAI como ilegal, fraudulento
                    ou enganador confere a esta o direito de inibir o Utilizador
                    de ter acesso à plataforma Hyundai Blue, podendo esta
                    inibição resultar também de decisão judicial ou ordem
                    administrativa.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{ lineHeight: "0.6cm", orphans: 2, widows: 2 }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      O acesso e utilização da plataforma Hyundai Blue pode ser
                      feito em duas modalidades, consoante os serviços em causa:{" "}
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <i>i)</i>
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      {" "}
                      gratuito, limitado aos serviços disponíveis para esse
                      efeito, suportando o Utilizador apenas os custos dos
                      serviços de dados/telecomunicações e{" "}
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <i>ii)</i>
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      {" "}
                      mediante pagamento.
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{ lineHeight: "0.6cm", orphans: 2, widows: 2 }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Para que possa utilizar os serviços pagos, o Utilizador
                      deverá ter preenchido corretamente os seus dados fiscais
                      (NIF – Número de Identificação Fiscal, em caso de pessoa
                      singular, ou NIPC - Número de Identificação de Pessoa
                      Coletiva, em caso de pessoa coletiva) e associado, pelo
                      menos, um meio de pagamento válido na plataforma Hyundai
                      Blue, i.e., um cartão de crédito que permita pagamentos
                      online.
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western" style={{ marginTop: "0.21cm" }}>
            Faturação
          </h1>
          <ol start={22}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Será emitida uma fatura eletrónica correspondente às
                    utilizações dos serviços pagos. O Utilizador consente, desde
                    já, em receber exclusivamente fatura eletrónica, que será
                    enviada para o endereço de email indicado pelo Utilizador no
                    processo de registo.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western">
            Condições de utilização dos serviços, preços e tarifários
          </h1>
          <ol start={23}>
            <li>
              <p lang="pt-PT" style={{ marginTop: "0.3cm" }}>
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os serviços descritos no número 14 têm as seguintes
                    condições de utilização:
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <ul>
            <li>
              <p
                lang="pt-PT"
                align="left"
                style={{ textIndent: "0cm", marginTop: "0.29cm" }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Alíneas a) a b) – são pagos;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                align="left"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.29cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Alíneas c) a k) - são gratuitos sujeitos à utilização dos
                    serviços a) e b).
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <ol start={24}>
            <li>
              <p lang="pt-PT" style={{ marginTop: "0.3cm" }}>
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Relativamente aos serviços descritos nas alíneas a) e b) do
                    número 14:
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <ol type="i">
            <li>
              <p
                lang="pt-PT"
                align="justify"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.2pt" }}></span>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    HYUNDAI disponibiliza um serviço para Utilizadores de
                    veículos elétricos, que incorpora o uso de um local para
                    estacionamento e carregamento;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                align="justify"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma Hyundai Blue disponibiliza carregamentos em
                    várias redes através de contratos instantâneos entre a EVIO
                    e o Utilizador;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                align="justify"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Ao aceder aos postos de carregamento, o Utilizador obriga-se
                    a respeitar todas as regras de utilização e condições
                    técnicas e de segurança aplicáveis e afixadas no posto de
                    carregamento em que o Utilizador se encontre;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                align="justify"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O serviço de mobilidade elétrica que inclui carregamento
                    inicia-se com a ativação do serviço pelo Utilizador através
                    da plataforma Hyundai Blue e termina com a respetiva
                    desativação;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                align="justify"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Antes de iniciar o carregamento da sua viatura e para que o
                    serviço possa ser prestado, o Utilizador terá de selecionar
                    o posto de carregamento e tomada onde pretende usufruir do
                    serviço e efetuar a sua autenticação. A autenticação pode
                    ser realizada através de leitura de um QR-Code (quando
                    disponível) ou através de menu apropriado na App ou de
                    cartão físico (quando disponibilizado pela HYUNDAI);
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                align="justify"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O valor a cobrar pelo serviço será medido através do tempo
                    de utilização do serviço e/ou dos kWh consumidos, podendo
                    acrescer uma componente de ativação dos serviços, roaming
                    e/ou de estacionamento após o término do carregamento. Os
                    valores fixados para utilização do serviço dependem da
                    qualidade do local de carregamento, tempo de utilização do
                    posto de carregamento, rede onde estão ligados os postos de
                    carregamento, potência do local, pontos de interesse nos
                    locais e outros serviços disponíveis. O Utilizador deve
                    consultar previamente na plataforma Hyundai Blue o tarifário
                    a cobrar para cada ponto de carregamento. Em função das
                    redes e dos locais, pode haver lugar à incidência de tarifas
                    praticadas por terceiros, taxas e eventuais impostos;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                align="justify"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os custos em que a HYUNDAI possa eventualmente incorrer
                    relacionados com o tempo máximo de utilização do serviço ou
                    de inatividade, bem como os custos de coimas ou serviços de
                    reboque decorrentes de estacionamento indevido ou abusivo,
                    serão imputados ao Utilizador, em conformidade com o
                    disposto na legislação e/ou regulamentação aplicável;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                align="justify"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A HYUNDAI não é responsável por qualquer custo, dano,
                    prejuízo ou lucro cessante que possa resultar para o
                    Utilizador da indisponibilidade ou de mau funcionamento do
                    posto de carregamento selecionado através da plataforma
                    Hyundai Blue. Verificando-se alguma destas situações, deve
                    ser contactada a entidade proprietária e/ou responsável pela
                    operação do posto de carregamento em causa.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <ol start={25}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    No final da utilização de cada serviço de utilização de
                    posto de carregamento sujeito a pagamento, a plataforma
                    Hyundai Blue apresenta ao Utilizador o valor a cobrar pelo
                    serviço prestado, assim como o respetivo
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-1.0pt" }}></span>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    detalhe.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.22cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Em caso de insucesso na cobrança do serviço, a HYUNDAI
                    reserva-se o direito de bloquear a utilização de todos os
                    serviços pelo Utilizador. Para voltar a utilizar os
                    serviços, o Utilizador deve atualizar os seus meios de
                    pagamento e pagar o valor em dívida.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western" style={{ marginTop: "0.21cm" }}>
            Operacionalidade da plataforma Hyundai Blue
          </h1>
          <ol start={27}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A HYUNDAI reserva-se o direito de interromper ou suspender
                    temporariamente, e sem aviso prévio, o acesso à plataforma
                    Hyundai Blue pelo período que determine como necessário, por
                    quaisquer razões de ordem técnica, administrativa ou de
                    força maior. O Utilizador reconhece que as interrupções no
                    serviço podem ocorrer devido a situação de força maior,
                    nesta se incluindo tremores de terra, inundações, incêndios,
                    epidemias, sabotagens, greves, embargos ou bloqueios
                    internacionais, atos de guerra ou terrorismo, motins,
                    situações de emergência, contingência ou estado de alarme
                    provocado por uma epidemia ou pandemia, bem como devido a
                    ações técnicas que tenham de ser realizadas no equipamento
                    para que este funcione corretamente ou para melhorar o
                    serviço (por exemplo, manutenção, reparações,
                    indisponibilidade de plataformas ou serviços de terceiros,
                    atualizações de software nos sistemas, nos servidores, e/ou
                    nas estações de carregamento). As interrupções, ou redução
                    do nível de serviço, podem também resultar de falta de
                    capacidade de curto prazo devido a picos de utilização,
                    resultantes de um acesso em simultâneo de vários
                    Utilizadores à plataforma Hyundai Blue, com o carregamento
                    na potência máxima.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.22cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A todo o tempo e sem necessidade de aviso prévio, poderá ser
                    alterada a apresentação e configuração da plataforma Hyundai
                    Blue.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A HYUNDAI compromete-se a realizar todos os esforços no
                    sentido de manter a operacionalidade e continuidade da
                    plataforma Hyundai Blue, para evitar a presença de vírus ou
                    outros elementos lesivos que possam provocar alterações no
                    sistema informático do Utilizador, bem como para fornecer
                    informação exata e atualizada. No entanto, e dada a
                    interligação com diferentes entidades que constituem fonte
                    de informação da plataforma Hyundai Blue, os conteúdos
                    poderão não estar sempre atualizados, apesar do esforço
                    efetuado de forma regular para esse efeito, nem a HYUNDAI
                    garante que a plataforma Hyundai Blue funcione corretamente
                    a todo o momento, de forma rápida, ininterrupta e livre de
                    erros. Igualmente, a HYUNDAI não pode garantir a ausência de
                    vírus ou elementos lesivos que possam provocar alterações
                    nos sistemas informáticos dos Utilizadores, nos seus
                    documentos eletrónicos ou nos seus ficheiros.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Em particular, e salvaguardadas situações de atuação dolosa
                    ou de negligência grosseira por parte da HYUNDAI, em
                    conformidade com a lei, não haverá responsabilização pelos
                    danos ou prejuízos verificados na esfera do Utilizador que
                    possam resultar de:
                  </font>
                </font>
              </p>
              <ol type="a">
                <li>
                  <p
                    lang="pt-PT"
                    style={{ textIndent: "0cm", marginTop: "0.21cm" }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Dispositivos móveis utilizados pelo Utilizador;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      marginTop: "0.3cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Impossibilidade ou dificuldades de utilização da
                        plataforma Hyundai Blue, incluindo, nomeadamente,
                        atrasos, interrupções, avarias, suspensão de
                        comunicações, vírus, suspensão ou qualquer outro
                        impedimento dos servidores onde o sistema se encontra
                        alojado;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      marginTop: "0.21cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Atrasos ou bloqueios no uso causados por deficiências ou
                        sobrecargas de Internet ou em outros sistemas
                        eletrónicos;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      marginTop: "0.22cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Possíveis erros ou deficiências de segurança que possam
                        ocorrer pelo uso, por parte do Utilizador, de
                        equipamentos, terminais ou browsers desatualizados ou
                        inseguros;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      marginTop: "0.21cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Falta de qualidade, atualidade, veracidade, licitude,
                        exatidão, completude, fiabilidade e/ou idoneidade de
                        conteúdos elaborados, produzidos, ou emitidos por
                        terceiros, assim como da existência de vícios ou
                        defeitos de qualquer tipo dos conteúdos transmitidos,
                        difundidos, armazenados e/ou colocados à disposição dos
                        Utilizadores por tais terceiros a que os Utilizadores
                        acedam através da plataforma Hyundai Blue ou dos
                        serviços oferecidos;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Atuações de terceiros que violem direitos de propriedade
                        intelectual, segredos empresariais, direito à honra, à
                        intimidade pessoal e à própria imagem, assim como a
                        legislação em matéria de concorrência desleal e
                        publicidade
                      </font>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <span style={{ letterSpacing: "-0.1pt" }}></span>
                      </font>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        ilícita;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      marginTop: "0.21cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Acessibilidade, funcionamento ou disponibilidade de
                        conteúdos, informação e serviços oferecidos por
                        terceiros nos portais ligados à plataforma Hyundai Blue,
                        assim como da sua qualidade, licitude, fiabilidade e
                        utilidade. O Utilizador reconhece que a plataforma
                        Hyundai Blue pode estar hiperligada a outros sites e que
                        a HYUNDAI não está, direta ou indiretamente, a sugerir
                        qualquer aprovação, associação, ligação ou relação com o
                        site hiperligado, a não ser que esteja especificamente
                        aí estabelecido. Ao entrar na plataforma Hyundai Blue, o
                        Utilizador reconhece e aceita que não foram revistos
                        todos os sites hiperligados à plataforma Hyundai Blue,
                        pelo que é eximida a responsabilidade pelo conteúdo de
                        qualquer das páginas off-site ou qualquer site a ele
                        hiperligado. A ligação do Utilizador a quaisquer outras
                        páginas off-site ou outros sites corre por sua própria
                        conta e risco.
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A HYUNDAI eliminará os conteúdos disponibilizados por
                    terceiros na plataforma Hyundai Blue no caso de ter
                    conhecimento efetivo de que estes são manifestamente ilegais
                    ou infringem direitos de terceiros, ou no caso de tal ser
                    ordenado por decisão judicial ou ordem administrativa.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A utilização e a qualidade da plataforma Hyundai Blue, em
                    especial quando acedida através de App, dependem do
                    dispositivo móvel utilizado para ceder à mesma, devendo o
                    Utilizador certificar-se que o equipamento e o respetivo
                    utilizado suportam a App. Ao descarregar a App, o Utilizador
                    reconhece e aceita que o seu dispositivo móvel permite o
                    funcionamento sistema operativo daquela.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Cabe ao Utilizador manter e conservar o dispositivo móvel no
                    qual descarregue a App em condições de segurança e seguir as
                    práticas de segurança aconselhadas pelo fabricante e pela
                    operadora de telecomunicações, devendo instalar e manter
                    atualizados os necessários mecanismos de segurança,
                    nomeadamente, um sistema antivírus.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Qualquer falha no funcionamento da App decorrente da falta
                    de cumprimento do disposto nos números anteriores será da
                    exclusiva responsabilidade do Utilizador, reconhecendo este
                    último que em caso algum poderá a HYUNDAI ser
                    responsabilizada.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma Hyundai Blue (incluindo a respetiva App) é
                    disponibilizada para uso exclusivo do Utilizador, que se
                    comprqomete a fazer uso da mesma em conformidade com a Lei e
                    com os presentes Termos e Condições, obrigando-se,
                    designadamente, a não a utilizar para fins ilícitos,
                    contrários ao estabelecido nos Termos e Condições, lesivos
                    dos direitos e interesses de terceiros ou que, de qualquer
                    forma, possam danificar, inutilizar, sobrecarregar ou
                    deteriorar o funcionamento normal da plataforma Hyundai
                    Blue. Em particular, é vedado realizar execuções
                    automatizadas/robotizadas na plataforma Hyundai Blue,
                    utilizar a plataforma Hyundai Blue com o objetivo de
                    aumentar as necessidades de processamento, de utilização de
                    dados ou de armazenamento da mesma e extrair da plataforma
                    Hyundai Blue qualquer tipo de informação para utilização com
                    fins comerciais sem a expressa autorização da Hyundai.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A HYUNDAI reserva-se o direito de bloquear o acesso do
                    Utilizador à App, assim como às respetivas funcionalidades
                    desta, caso o Utilizador não cumpra o disposto nos n.ºs 31,
                    32, e 33.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador deverá reportar à HYUNDAI quaisquer anomalias
                    que detete relativamente ao uso da plataforma Hyundai Blue,
                    bem como quaisquer ações fraudulentas de terceiros.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western" style={{ marginTop: "0.09cm" }}>
            Direitos de propriedade intelectual
          </h1>
          <ol start={39}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O conteúdo e a estrutura da plataforma Hyundai Blue,
                    incluindo aplicações, software, algoritmos, arquitetura,
                    design,{" "}
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>look &amp; feel</i>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , base de dados,{" "}
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>libraries</i>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , trabalhos derivados e desenvolvimentos futuros, é
                    protegido por direitos de propriedade intelectual HYUNDAI,
                    que abrangem direitos de autor e direitos conexos e direitos
                    de propriedade industrial, ao abrigo da legislação
                    portuguesa e europeia, incluindo, mas não limitando,
                    direitos sui generis do autor de bases de dados, direitos
                    sobre design, obras e elementos publicitários, invenções
                    (incluindo patentes e modelos industriais), modelos e
                    desenhos, sinais distintivos de comércio (incluindo marcas,
                    logótipos, recompensas, nomes de estabelecimento e
                    insígnias), firmas e nomes comerciais, bem como segredos
                    comerciais,{" "}
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>know-how</i>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    {" "}
                    e todos os outros direitos de caráter semelhante, incluindo
                    pedidos e aplicações para registo e independentemente de tal
                    registo ter sido efetuado ou de os direitos em questão não
                    estarem sujeitos a registo.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    É vedado, em qualquer circunstância, adaptar, tentar
                    modificar ou alterar o código-fonte, efetuar operações de
                    engenharia reversa, criar obras derivadas do software,
                    descompilar ou desmontar, no todo ou em parte, qualquer dos
                    elementos que integram a plataforma Hyundai Blue, bem como
                    reproduzir, transferir, ceder, alugar, vender ou de qualquer
                    outro modo transmitir direitos de utilização da plataforma
                    Hyundai Blue, temporária ou permanentemente, salvo
                    autorização expressa da HYUNDAI e da EVIO.{" "}
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.22cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Todas as tentativas de adulteração dos conteúdos ou da
                    estrutura da plataforma Hyundai Blue e seus meios anexos, ou
                    qualquer outra ação que possa causar danos e pôr em risco a
                    integridade do sistema, podem ser objeto de processo
                    judicial.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western">
            Cessação
          </h1>
          <ol start={42}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.29cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A HYUNDAI poderá cessar a utilização da plataforma Hyundai
                    Blue pelo Utilizador quando ocorra alguma violação dos
                    presentes Termos e Condições, mediante comunicação escrita.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador{" "}
                  </font>
                  pode cancelar livremente o seu registo na
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Plataforma Hyundai Blue, sem necessidade de indicar o
                    motivo, sem prejuízo da obrigação do Utilizador efetuar o
                    pagamento dos montantes correspondentes aos serviços
                    prestados até ao cancelamento do registo.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western" align="left">
            Comunicações
          </h1>
          <ol start={44}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Caso a HYUNDAI necessite de entrar em contacto com o
                    Utilizador, poderá utilizar os seguintes canais: carta,
                    e-mail, SMS e notificações
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.1pt" }}></span>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>push.</i>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Mediante o consentimento do utilizador, a HYUNDAI poderá
                    enviar comunicações relativas a:
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <ol type="a">
            <li>
              <p
                lang="pt-PT"
                style={{ textIndent: "0cm", marginTop: "0.21cm" }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Funcionalidades e serviços da plataforma Hyundai Blue;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p lang="pt-PT" style={{ textIndent: "0cm", marginTop: "0.3cm" }}>
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Novos produtos e promoções da HYUNDAI;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p lang="pt-PT" style={{ textIndent: "0cm", marginTop: "0.3cm" }}>
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>Newsletters</i>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    {" "}
                    e outras informações de{" "}
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>marketing</i>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    {" "}
                    relativas à marca
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.6pt" }}>
                      {" "}
                      Hyundai Blue,{" "}
                    </span>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    HYUNDAI e respetivas parcerias.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <ol start={46}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.29cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador poderá contactar a HYUNDAI através dos
                    seguintes canais:
                  </font>
                </font>
              </p>
              <ol type="a">
                <li>
                  <p lang="pt-PT">
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Atendimento telefónico comercial, através do número
                        disponibilizado na plataforma Hyundai Blue para o
                        efeito, disponível no horário de Portugal Continental
                        das 9h às 18h nos dias úteis (2.ªf a 6.ªf);
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      marginTop: "0.29cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Através do endereço de correio eletrónico{" "}
                        <a href="mailto:%20suporte_blu-e@hyundai.pt">
                          suporte_blu-e@hyundai.pt
                        </a>{" "}
                        ;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      marginTop: "0.29cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Funcionalidade de suporte existente na plataforma
                        Hyundai Blue para telemóvel;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    lang="pt-PT"
                    style={{
                      marginRight: "0.2cm",
                      textIndent: "0cm",
                      marginTop: "0.29cm",
                      lineHeight: "115%",
                    }}
                  >
                    <font size={2} style={{ fontSize: "11pt" }}>
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Através de carta, enviada para a morada Rua Daciano
                        Baptista Marques 245, Edifício D, 5ºC, Lake Towers,
                        4400-617 Vila Nova de Gaia
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <br />
          <h1 lang="pt-PT" className="western" style={{ marginTop: "0.21cm" }}>
            Resolução de conflitos
          </h1>
          <ol start={47}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  marginTop: "0.3cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Em caso de existência de conflito, nomeadamente sobre a
                    interpretação, execução e aplicação das disposições legais
                    ou contratuais aplicáveis, o Utilizador e a HYUNDAI
                    procurarão resolvê-lo amigavelmente.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.2cm",
                  textIndent: "0cm",
                  lineHeight: "115%",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Sem prejuízo da possibilidade de recorrer aos tribunais
                    judiciais, quando o Utilizador seja uma pessoa singular que
                    atue, no contexto dos presentes Termos e Condições, com fins
                    que não se integrem no âmbito da sua atividade comercial,
                    industrial, artesanal ou profissional (i.e., um consumidor),
                    pode optar por solicitar a intervenção de uma entidade de
                    resolução alternativa de litígios, nomeadamente através do
                    recurso aos mecanismos de arbitragem e mediação de conflitos
                    previstos no site da Direção-Geral do Consumidor em{" "}
                  </font>
                  <font color="#0563c1">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.1pt" }}>
                        <u>
                          <a href="https://www.consumidor.gov.pt/ral-mapa-e-lista-de-entidades.aspx">
                            https://www.consumidor.gov.pt/ral-mapa-e-lista-de-entidades.aspx
                          </a>
                        </u>
                      </span>
                    </font>
                  </font>
                  <font size={3} style={{ fontSize: "12pt" }}>
                    {" "}
                    e a seguir indicados:
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            lang="pt-PT"
            className="western"
            style={{
              marginLeft: "1cm",
              marginRight: "0.2cm",
              textIndent: "0cm",
              marginTop: "0.09cm",
              lineHeight: "115%",
            }}
          >
            CNIACC – Centro Nacional de Informação e Arbitragem de Conflitos de
            Consumo (
            <a href="http://www.arbitragemdeconsumo.org/">
              www.arbitragemdeconsumo.org
            </a>
            ); CIMAAL – Centro de Informação, Mediação e Arbitragem de Conflitos
            de Consumo do Algarve (
            <a href="http://www.consumidoronline.pt/">
              www.consumidoronline.pt
            </a>
            ); Centro de Arbitragem de Conflitos de Consumo do Distrito de
            Coimbra (
            <a href="http://www.centrodearbitragemdecoimbra.com/">
              www.centrodearbitragemdecoimbra.com
            </a>
            ); Centro de Arbitragem de Conflitos de Consumo de Lisboa (
            <a href="http://www.centroarbitragemlisboa.pt/">
              www.centroarbitragemlisboa.pt
            </a>
            ); Centro de Informação de Consumo e Arbitragem do Porto (
            <a href="http://www.cicap.pt/">www.cicap.pt</a> );
            <span style={{ letterSpacing: "-0.6pt" }}></span>Centro de
            Arbitragem de Conflitos de Consumo do Vale do Ave (
            <a href="http://www.triave.pt/">www.triave.pt</a> );
            <span style={{ letterSpacing: "1.1pt" }}></span>Centro de
            Informação, Meditação e Arbitragem de Consumo(
            <a href="http://www.ciab.pt/">
              <font color="#0563c1">
                <u>www.ciab.pt</u>
              </font>
            </a>
            ); Centro de Arbitragem de Conflitos de Consumo da Madeira (
            <a href="http://www.srrh.gov-madeira.pt/">
              www.srrh.gov-madeira.pt
            </a>
            ) e Centro de Arbitragem da Universidade Autónoma de Lisboa (
            <a href="http://arbitragem.autonoma.pt/">
              <font color="#0563c1">
                <u>http://arbitragem.autonoma.pt</u>
              </font>
            </a>
            ).
          </p>
          <p
            lang="pt-PT"
            align="center"
            style={{ marginLeft: "0cm", lineHeight: "0.6cm" }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            align="center"
            style={{ marginLeft: "0cm", lineHeight: "0.6cm" }}
          >
            <br />
          </p>
          <p lang="pt-PT">
            <font size={2} style={{ fontSize: "11pt" }}>
              <i>Termos e Condições Hyundai Blue</i>
            </font>
          </p>
          <p lang="pt-PT">
            <font size={2} style={{ fontSize: "11pt" }}>
              <i>v. 1.0 – Data 20/06/2023</i>
            </font>
          </p>
          <p
            lang="pt-PT"
            align="center"
            style={{ marginLeft: "0cm", lineHeight: "0.6cm" }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            align="center"
            style={{ marginLeft: "0cm", lineHeight: "0.6cm" }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            align="center"
            style={{ marginLeft: "0cm", lineHeight: "0.6cm" }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            align="center"
            style={{ marginLeft: "0cm", lineHeight: "0.6cm" }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            align="center"
            style={{ marginLeft: "0cm", lineHeight: "0.6cm" }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            align="center"
            style={{
              marginLeft: "0cm",
              lineHeight: "0.6cm",
              pageBreakBefore: "always",
            }}
          >
            <font size={2} style={{ fontSize: "11pt" }}>
              <font face="Calibri, serif">
                <b>Anexo I</b>
              </font>
            </font>
          </p>
          <p
            lang="pt-PT"
            className="western"
            align="center"
            style={{
              marginLeft: "0cm",
              textIndent: "0cm",
              lineHeight: "0.6cm",
            }}
          >
            <font size={2} style={{ fontSize: "11pt" }}>
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <b>
                    Carregamento de veículos elétricos em postos integrados na
                    rede portuguesa MOBI.E
                  </b>
                </font>
              </font>
            </font>
          </p>
          <p
            lang="pt-PT"
            className="western"
            align="center"
            style={{
              marginLeft: "0cm",
              textIndent: "0cm",
              lineHeight: "0.6cm",
            }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            className="western"
            align="justify"
            style={{
              marginLeft: "0cm",
              textIndent: "0cm",
              lineHeight: "0.6cm",
            }}
          >
            <font size={2} style={{ fontSize: "11pt" }}>
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  A plataforma Hyundai Blue disponibiliza carregamentos ad hoc
                  na rede MOBI.E através de contratos instantâneos entre a EVIO,
                  na qualidade de comercializador de eletricidade para a
                  mobilidade elétrica, titular do registo n.º 20, de 10 de julho
                  de 2020 (“CEME”), e o Utilizador, nas condições constantes dos
                  números seguintes:
                </font>
              </font>
            </font>
          </p>
          <ol>
            <li>
              <p
                lang="pt-PT"
                style={{
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Ao aceder aos postos de carregamento da rede MOBI.E, o
                      Utilizador obriga-se a cumprir as{" "}
                      <a href="https://www.mobie.pt/documents/42032/192209/Condi%C3%A7%C3%B5es+de+Utiliza%C3%A7%C3%A3o+da+Rede+de+Mobilidade+El%C3%A9trica_Fase+de+Mercado.pdf/21d83f9a-7936-fcf3-5dde-88dcf593f058?t=1634730974710">
                        Condições de Utilização da Rede de Mobilidade Elétrica
                      </a>{" "}
                      (disponível em{" "}
                      <a href="https://www.mobie.pt/utilizar-a-rede">
                        https://www.mobie.pt/utilizar-a-rede
                      </a>
                      ) em cada momento vigentes e a respeitar todas as regras
                      de utilização e condições técnicas e de segurança
                      aplicáveis e afixadas no posto de carregamento em que o
                      Utilizador se encontre.
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      O preço de fornecimento devido pelo Utilizador por cada
                      carregamento de bateria de veículo elétrico é composto
                      pelo somatório das seguintes componentes, discriminadas
                      nas faturas:
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <ol type="a">
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.21cm",
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        Preço de energia, em função da quantidade total de
                        eletricidade em quilowatt hora (kWh) fornecida em cada
                        carregamento;
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.21cm",
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        Preço de utilização do ponto de carregamento, afixado no
                        local e que é cobrado pelo operador do ponto de
                        carregamento (“OPC”) à EVIO, na qualidade de CEME, que o
                        repercute no preço devido pelo utilizador;
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{ textIndent: "0cm", lineHeight: "0.6cm" }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        Tarifas de ativação praticadas pelo CEME e OPC;
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.21cm",
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        Tarifas de acesso às redes de energia elétrica para a
                        mobilidade elétrica, fixadas pela Entidade Reguladora
                        dos Serviços Energéticos (“ERSE”), calculadas em função
                        do tipo de fornecimento (ponto de entrega da Rede
                        Elétrica de Serviço Público à rede da mobilidade
                        elétrica em baixa tensão ou média tensão) e período
                        horário;
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.21cm",
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        IVA à taxa legal em vigor no momento da emissão da
                        fatura, Imposto Especial sobre o Consumo, bem como
                        eventuais outros impostos, taxas, encargos ou
                        contribuições legalmente aplicáveis ao fornecimento de
                        eletricidade para a mobilidade elétrica no momento da
                        emissão da fatura;
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  marginRight: "0.21cm",
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        Apoios financeiros do Estado traduzidos em desconto a
                        aplicar ao custo de cada carregamento registado na rede
                        de mobilidade elétrica portuguesa.
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <ol start={3}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        É disponibilizada ao Utilizador, através dos canais de
                        comunicação da Hyundai Blue e da EVIO, a informação
                        sobre rotulagem de energia elétrica para carregamento de
                        veículos elétricos regulamentarmente exigida.
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        O Utilizador é informado e dá consentimento a um
                        eventual tratamento de dados pessoais (endereço de
                        e-mail) pela Entidade Gestora da Mobilidade Elétrica
                        (“EGME”) para efeitos de notificação da cessação do
                        contrato de adesão à rede de mobilidade elétrica
                        relativamente ao CEME EVIO, nos termos previstos no
                        Regulamento da Mobilidade Elétrica.
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        O Utilizador poderá contactar a EVIO através dos
                        seguintes canais:
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <ol>
            <ol type="a">
              <li>
                <p
                  lang="pt-PT"
                  style={{ lineHeight: "0.6cm", orphans: 2, widows: 2 }}
                >
                  <font size={2} style={{ fontSize: "11pt" }}>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <span style={{ letterSpacing: "-0.3pt" }}>
                          Atendimento telefónico comercial, através do número
                          disponibilizado na plataforma EVIO para o efeito,
                          disponível no horário de Portugal Continental das 9h
                          às 18h nos dias úteis (2.ªf a 6.ªf);
                        </span>
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  lang="pt-PT"
                  style={{ lineHeight: "0.6cm", orphans: 2, widows: 2 }}
                >
                  <font size={2} style={{ fontSize: "11pt" }}>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <span style={{ letterSpacing: "-0.3pt" }}>
                          Formulário eletrónico de contacto disponível em{" "}
                          <a href="https://evio.pt/">https://evio.pt/</a>;
                        </span>
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  lang="pt-PT"
                  style={{ lineHeight: "0.6cm", orphans: 2, widows: 2 }}
                >
                  <font size={2} style={{ fontSize: "11pt" }}>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <span style={{ letterSpacing: "-0.3pt" }}>
                          Endereço de correio eletrónico{" "}
                          <a href="support@go-evio.com">support@go-evio.com</a>;
                        </span>
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  lang="pt-PT"
                  style={{ lineHeight: "0.6cm", orphans: 2, widows: 2 }}
                >
                  <font size={2} style={{ fontSize: "11pt" }}>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <span style={{ letterSpacing: "-0.3pt" }}>
                          Funcionalidade de suporte existente na App EVIO para
                          telemóvel;
                        </span>
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  lang="pt-PT"
                  style={{ lineHeight: "0.6cm", orphans: 2, widows: 2 }}
                >
                  <font size={2} style={{ fontSize: "11pt" }}>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <span style={{ letterSpacing: "-0.3pt" }}>
                          Carta, enviada para a morada Avenida Dom Afonso
                          Henriques, n.º 1825, 4450-017 Matosinhos.
                        </span>
                      </font>
                    </font>
                  </font>
                </p>
              </li>
            </ol>
          </ol>
          <ol start={6}>
            <li>
              <p
                lang="pt-PT"
                style={{
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        A EVIO disponibiliza ao Utilizador que efetue
                        carregamentos na rede MOBI.E os meios de atendimento
                        previstos no ponto 5, podendo o Utilizador apresentar
                        reclamação através de qualquer um dos canais de
                        atendimento das alíneas c) e e) do ponto 5 ou através do
                        livro de reclamação em formato eletrónico, cujo acesso é
                        disponibilizado através de página de internet.
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        A EVIO obriga-se a responder a todas as reclamações que
                        lhe sejam dirigidas através de qualquer um dos canais de
                        atendimento das alíneas c) e e) do ponto 5 no prazo
                        máximo de 15 dias úteis após a data da sua receção.
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                lang="pt-PT"
                style={{
                  textIndent: "0cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font size={2} style={{ fontSize: "11pt" }}>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.3pt" }}>
                        A EVIO não fica obrigada a suportar qualquer compensação
                        ao Cliente nas situações originadas por casos fortuitos
                        ou de força maior, no sentido dado pelo artigo 8.º do
                        Regulamento da Qualidade de Serviço, aprovado pelo
                        Regulamento n.º 406/2021, de 12 de maio, da ERSE.
                      </span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            lang="pt-PT"
            className="western"
            align="justify"
            style={{
              marginLeft: "0cm",
              textIndent: "0cm",
              lineHeight: "0.6cm",
              pageBreakBefore: "always",
            }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            className="western"
            align="center"
            style={{
              marginLeft: "0cm",
              textIndent: "0cm",
              marginTop: "0.11cm",
            }}
          >
            <br />
          </p>
          <p
            lang="pt-PT"
            className="western"
            align="left"
            style={{ marginLeft: "0cm", textIndent: "0cm", marginTop: "0cm" }}
          >
            <br />
          </p>
        </div>
      </div>
    );
  }
}

export default TC;
